import { render, staticRenderFns } from "./NflTopPlaysTable.vue?vue&type=template&id=d86d9382&scoped=true"
import script from "./NflTopPlaysTable.vue?vue&type=script&lang=js"
export * from "./NflTopPlaysTable.vue?vue&type=script&lang=js"
import style0 from "./NflTopPlaysTable.vue?vue&type=style&index=0&id=d86d9382&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d86d9382",
  null
  
)

export default component.exports